
import { useState } from 'react';
import Button from '../../../components/base/Button';
import BusinessProfileModal from '../../../components/feature/BusinessProfileModal';

export default function HeroSection() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <section 
        className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://public.readdy.ai/ai/img_res/dd59f5df39ca556c412f39913c1b62b2.jpg')`
        }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
          <div className="text-center text-white">
            <h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight">
              We help Taiwanese Business
              <br />
              <span className="text-blue-400">Enter US Market</span>
            </h1>
            <p className="text-xl md:text-2xl mb-8 max-w-3xl mx-auto text-gray-200">
              Comprehensive support for Taiwanese companies expanding into the United States. From market entry to business setup, we provide the expertise and resources you need.
            </p>
            <div className="flex justify-center">
              <Button
                onClick={() => setIsModalOpen(true)}
                className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 text-lg font-semibold rounded-lg transition-colors cursor-pointer whitespace-nowrap"
              >
                Create Profile
              </Button>
            </div>
          </div>
        </div>
      </section>

      <BusinessProfileModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)} 
      />
    </>
  );
}
